import { render, staticRenderFns } from "./ManagedAccountConfirmPortfolio.vue?vue&type=template&id=2bf20cb1"
import script from "./ManagedAccountConfirmPortfolio.vue?vue&type=script&lang=ts"
export * from "./ManagedAccountConfirmPortfolio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports